export default __webpack_public_path__ + "static/media/circle2.30d036f0.png";